/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import TemplateModel from 'cio/models/template';
import { InAppPreview } from 'cio/utils/previews';
import { inject as service } from '@ember/service';
import ApiService from 'cio/services/api';
import { tracked } from '@glimmer/tracking';
import { task, timeout } from 'ember-concurrency';
import Ember from 'ember';
import config from 'cio/config/environment';
import getPreviewVariables from 'cio/utils/get-preview-variables';
import { isBlank } from '@ember/utils';
import { Editor } from 'cio/services/editor';

const PREVIEW_DEBOUNCE_DELAY = config.APP.debounceDuration;

interface PreviewerArgs {
  template: TemplateModel;
}

export default class Previewer extends Component<PreviewerArgs> {
  @service api!: ApiService;
  @tracked preview!: InAppPreview;

  fetchPreview = task({ restartable: true }, async () => {
    if (!Ember.testing) {
      await timeout(PREVIEW_DEBOUNCE_DELAY);
    }

    let data = this.getPreviewData();
    if (isBlank(data.body_json)) {
      return;
    }

    let templateVariables = this.fetchTemplateVariables.last?.value;
    if (!templateVariables) {
      templateVariables = await this.fetchTemplateVariables.perform();
    }

    let variables = getPreviewVariables({ templateVariables });
    let url = 'previews/in_app';
    this.preview = await this.api.post(url, {
      data: { ...data, variables },
    });
  });

  private getPreviewData() {
    /* eslint-disable @typescript-eslint/naming-convention */
    let { recipient: to, bodyJson: body_json } = this.args.template;
    return { to, body_json, editor: Editor.JSON };
    /* eslint-enable @typescript-eslint/naming-convention */
  }

  fetchTemplateVariables = task({ drop: true }, async () => {
    let { variables } = await this.args.template.fetchPreviewVariables({});
    return variables;
  });
}
